<script setup lang="ts">
import { AppSvgIcon } from '@libs/ui';

interface BuildYourTripPanelEmits {
  (event: 'build-your-trip'): void;
}

const emit = defineEmits<BuildYourTripPanelEmits>();
</script>

<template>
  <div class="build-your-trip-panel">
    <div class="heading-4">
      {{ $t('planner.recipe_view.all_in_one_travel_planner') }}
    </div>
    <div class="subheading">
      {{
        $t(
          'planner.recipe_view.instantly_compare_flights_hotels_and_activities_at_same_time'
        )
      }}
    </div>
    <button
      class="search-destination-button"
      @click="emit('build-your-trip')"
      @onKeyDown.enter="emit('build-your-trip')"
    >
      <AppSvgIcon
        name="lookingGlass"
        size="24"
        color="color-neutral-70"
        class="icon"
      />
      <span class="text">{{ $t('planner.where_to_travel') }}</span>
    </button>
  </div>
</template>

<style scoped lang="scss">
.build-your-trip-panel {
  background: var(--color-white);
  border-radius: var(--border-radius-12);
  padding: var(--spacing-32) var(--spacing-24);
  height: 100%;

  @include for-less-or-equal-than-599-px {
    border-radius: 0;
  }
  .heading-4 {
    @include font-heading-4;
    margin-bottom: var(--spacing-8);
    color: var(--color-neutral-70);
  }

  .subheading {
    @include font-body-l-light;
    margin-bottom: var(--spacing-24);
    color: var(--color-neutral-70);
  }

  .search-destination-button {
    all: unset;
    width: 100%;
    height: 56px;
    background-color: var(--color-neutral-10);
    border-radius: var(--border-radius-8);
    cursor: pointer;
    transition: var(--transition-short);

    display: flex;
    align-items: center;
    gap: var(--spacing-16);

    .icon {
      margin-left: var(--spacing-16);
    }

    .text {
      @include font-label-l-bold;
      color: var(--color-neutral-60);
    }
    @include on-hover {
      background-color: var(--color-neutral-30);
    }
  }
}
</style>
